import { FaxLocationMapping } from "@/src/models/constants/fax-location";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getFaxLocationAssignment(taskId: string): Promise<FaxLocationMapping> {
  return fetchJSON<FaxLocationMapping>(`/api/tasks/${taskId}/fax-location-assignment`);
}
